(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('batch-jobs-monitoring', {
            parent: 'entity',
            url: '/batch-jobs-monitoring',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle:'Suivi batch'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/batch-jobs/batch-jobs.html',
                    controller: 'BatchJobsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        
        
        
        ;
    }

})();
